import * as React from 'react';
import styled from 'styled-components';
import { BORDER_COLOUR } from 'govuk-colours';
import { SPACING_POINTS } from '@govuk-react/constants';
import { spacing, typography } from '@govuk-react/lib';
import Tag from '@govuk-react/tag';

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var _excluded = ["level", "children"];
var StyledBanner = styled('div').withConfig({
  displayName: "src__StyledBanner",
  componentId: "sc-11ccy2-0"
})({
  paddingTop: SPACING_POINTS[2],
  paddingBottom: SPACING_POINTS[2],
  borderBottom: "1px solid ".concat(BORDER_COLOUR)
}, spacing.withWhiteSpace());
var BannerContent = styled('p').withConfig({
  displayName: "src__BannerContent",
  componentId: "sc-11ccy2-1"
})(typography.font({
  size: 16
}), typography.textColour, _defineProperty({
  display: 'table',
  margin: 0
}, String(Tag), {
  marginRight: SPACING_POINTS[2]
}));
var BannerText = styled('span').withConfig({
  displayName: "src__BannerText",
  componentId: "sc-11ccy2-2"
})({
  display: 'table-cell',
  verticalAlign: 'baseline'
});
/**
 * Use the phase banner component to show users your service is still being worked on.
 *
 * - https://govuk-react.github.io/govuk-react/?path=/docs/phase-banner
 * - https://design-system.service.gov.uk/components/phase-banner/
 */

var PhaseBanner = function PhaseBanner(_ref) {
  var level = _ref.level,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(StyledBanner, props, /*#__PURE__*/React.createElement(BannerContent, null, /*#__PURE__*/React.createElement(Tag, null, level), /*#__PURE__*/React.createElement(BannerText, null, children)));
};
PhaseBanner.displayName = 'PhaseBanner';

export { PhaseBanner, PhaseBanner as default };
